'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isPlainObject(object) {
    if ((typeof object === "undefined" ? "undefined" : _type_of(object)) !== 'object') {
        return false;
    }
    if (object == null) {
        return false;
    }
    if (Object.getPrototypeOf(object) === null) {
        return true;
    }
    if (Object.prototype.toString.call(object) !== '[object Object]') {
        var _Object_getOwnPropertyDescriptor;
        var tag = object[Symbol.toStringTag];
        if (tag == null) {
            return false;
        }
        var isTagReadonly = !((_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(object, Symbol.toStringTag)) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.writable);
        if (isTagReadonly) {
            return false;
        }
        return object.toString() === "[object ".concat(tag, "]");
    }
    var proto = object;
    while(Object.getPrototypeOf(proto) !== null){
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(object) === proto;
}
exports.isPlainObject = isPlainObject;
